import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';



@Component({
  selector: 'app-moniepoint-amount',
  templateUrl: './moniepoint-amount.component.html',
  styleUrls: ['./moniepoint-amount.component.scss'],
})

export class MoniepointAmountComponent implements OnInit {
  @Output() getAmount = new EventEmitter();
  inputClass = '';
  @Input() showLabel: boolean;
  @Input() showError: boolean;
  @Input() label: string;
  @Input() errorMessage: string;
  @Input() minAmount: any;
  @Input() initialAmount: any;
  inputValue: any;
  error: boolean;
  @Input() showAmountRange: boolean;
  @Input() disableInput: boolean;
  @Input() maxAmount: any;
  @Input() inputHeightForMobile: boolean = false;
  @Input() selectedAmount? = null;

  constructor() { }

  ngOnInit(): void {
    this.initialize();
  }

  /**
   * reduces the font sizes as the amount get increased
   * @returns
   */
  fontSize() {
    if (this.inputValue) {
      let size = (34 - this.inputValue?.toString().length / 2);
      if (this.inputValue?.toString().length < 18) {
        size -= 1;
      } else {
        size = size- 3;
      }
      size = Math.floor(size);
      return size;
    } else {
      let size = (34 - this.initialAmount?.toString().length / 2);
      size -= 1;
      size = Math.ceil(size);
      return size;
    }
  }

  initialize() {
    if (this.label) {
      this.showLabel = true;
    }
    if (this.errorMessage) {
      this.showError = true;
    }
    if (!this.minAmount) {
      this.minAmount = 0;
    }
    if (this.initialAmount) {
      const refinedAmount = parseFloat(this.initialAmount).toFixed(2);
      this.formatNumber({ value: refinedAmount });
    }
    else {
      this.inputValue = '0.00';
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.selectedAmount?.currentValue) {
      const refinedAmount = parseFloat(changes.selectedAmount.currentValue).toFixed(2);
      this.formatNumber({ value: refinedAmount });
		}
	}

  formatNumber($event) {
    let amount = $event?.value?.toString().replace('.', '');
    amount = amount.replace(/[^\d]/g, '');
    let newAmount: any = this.getNewAmount(amount);
    const saved = newAmount;
    const dot_pos = newAmount.length - 2;
    const non_decimal_side = newAmount.substring(0, dot_pos);
    const decimal_side = newAmount.substring(dot_pos);
    let amountInCurrency: any = `${non_decimal_side}.${decimal_side}`;
    if (!non_decimal_side && !decimal_side) {
      amountInCurrency = 0;
    }
    const finalAmount = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amountInCurrency);
    this.inputValue = finalAmount;
    this.emitAmount(saved);
  }

  emitAmount(amount) {
    const newAmount = Number(amount);
    const majorAmount = newAmount / 100;
    if (this.maxAmount) {
      if (majorAmount > this.maxAmount) {
        this.getAmount.emit(majorAmount);
        this.error = true;
        this.setInputClass(2);
        return;
      }
    }

    if (this.minAmount) {
      if (majorAmount < this.minAmount) {
        this.error = true;
        this.getAmount.emit(majorAmount);
        this.setInputClass(2)
        return;
      }
    }

    this.getAmount.emit(majorAmount);
    this.error = false;
    this.setInputClass(1)
    return;
  }

  getNewAmount(amount) {
    let newAmount: any = '';
    const arr = amount.split(',');
    arr.forEach(e => {
      newAmount += e;
    })
    return newAmount;
  }


  setInputClass(action) {
    if (this.error) {
      action = 2;
    }
    else if (this.disableInput) {
      action = 3;
    }
    switch (action) {
      case 1:
        this.inputClass = 'input-focus';
        break;
      case 2:
        this.inputClass = 'input-error';
        break;
      default:
        this.inputClass = '';
    }
  }
}
